import { useEffect  } from 'react';
// import '../../App.css';
// import OtherUserProfile from '../OtherUserProfile';
// import './css/SignUp.css';
// import axios from "axios";
// import baseurl from "../../App"

export const Logout = () => {
    // const [inputs, setInputs] = useState({});
	// const [credentialError, setCredentialError] = useState('');
    
	// setCredentialError("Get Started");
	
	useEffect(() => {
		const loggedInUser = localStorage.setItem("user", {});
		window.location.href='/';
	  }, []);

    return (
        ""
        // <div className='container'>
        //     <div className='signup-container'>
        //         <img className='signup-logo' src='./images/bubble.svg' alt='logo'/>
        //         <h3 className='subheader green-text'>Welcome back To Bubble</h3>
        //         <p className='maintext signup-sub'>{credentialError ? credentialError: "Enter your email and password"}</p>
        //         {/* <div className='continuewithgoogle'>
        //             <div className='google-text'>
        //                 <p className='googletext'>Continue with Google  <img src='../../images/google-logo.png' alt='google-logo' width='21px'/>
        //                 </p>
        //             </div>
        //         </div>
        //         <div className='signup-group'>
        //             <hr className='signup-hr'/>
        //             <p className='maintext'>or</p>
        //             <hr className='signup-hr'/>
        //         </div> */}
        //         <form className='signup' onSubmit={handleSubmit}>
        //             <input name="email" value={inputs.email || ""} onChange={handleChange} type="email" className="signup-input" placeholder="Enter your email address" />
        //             <input name="password" value={inputs.password || ""} onChange={handleChange} type="password" className="signup-input" placeholder="Enter your password" />
        //             <p className='subtext left'> <a href='/login' >Forgot your password?</a></p>
        //             <button className='signup-submit' type = 'submit'>Login</button>
        //             {/* <input type="submit"  className='signup-submit' value="Login"/> */}
        //         </form>
        //         {/* <p>{testing}</p> */}
        //         <p className='subtext'>Don't have an account? <a href="/sign-up">Sign Up</a></p><br/><br/><br/>
        //         </div>
            
        // </div>
        
    )
}

// export default Logout;